<template>

    <AdminBlock>
        <div class="d-flex justify-content-end">
            <a :href="backToJobLink()" class="btn btn-danger btn-sm">
                Back to Job
            </a>
        </div>
    </AdminBlock>

    <AdminBlock title="Select Customer">
        <CustomerSelect
            :customer="form.selectedCustomer"
            remove-margin
        />
    </AdminBlock>

    <div class="">
        <div class="row">
            <div :class="{ 'col-lg-4': job.aborted_at_movement_id !== null, 'col-lg-7': job.aborted_at_movement_id === null }">
                <AdminBlock title="Job">
                    <div class="row">
                        <div class="col-md-6 mb-4 mb-md-0">
                            <div class="form-group">
                                <label for="notes">
                                    <strong>
                                        Internal Notes
                                    </strong>
                                </label>
                                <textarea
                                    v-model="form.notes"
                                    placeholder="Internal Notes"
                                    id="notes"
                                    class="form-control"
                                    name="notes"
                                    rows="8"
                                ></textarea>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="initial_driver_notes">
                                    <strong>
                                        Initial Driver Notes
                                    </strong>
                                </label>
                                <textarea
                                    v-model="form.initial_driver_notes"
                                    id="initial_driver_notes"
                                    class="form-control"
                                    name="initial_driver_notes"
                                    placeholder="These notes will appear before any other notes entered later for all movements in the job."
                                    rows="8"
                                ></textarea>
                            </div>
                        </div>
                    </div>
                </AdminBlock>
            </div>
            <div
                v-if="job.aborted_at_movement_id !== null"
                class="col-lg-4"
            >
                <AdminBlock title="Aborted Reason">
                    <div class="form-group">
                        <label>
                            <strong>
                                Driver Reason
                            </strong>
                        </label>
                        <p>
                            {{ job.aborted_driver_reason || 'No Driver reason set' }}
                        </p>
                    </div>
                    <div class="form-group">
                        <label>
                            <strong>
                                Admin Reason
                            </strong>
                        </label>
                        <textarea
                            v-model="form.aborted_admin_reason"
                            class="form-control"
                            rows="4"
                            placeholder="Admin Reason"
                        ></textarea>
                    </div>
                </AdminBlock>
            </div>
            <div :class="{ 'col-lg-4': job.aborted_at_movement_id !== null, 'col-lg-5': job.aborted_at_movement_id === null }">
                <AdminBlock title="Contract">
                    <template v-slot:options>
                        <a :href="generateMoveRoute()" class="btn btn-warning btn-sm">
                            <i class="fa fa-fw fa-user"></i>
                            Move to other customer
                        </a>
                    </template>
                    <fieldset class="">
                        <ContractSelect
                            v-model="form.selectedContract"
                            :customer="form.selectedCustomer"
                            :contract="form.selectedContract"
                        />
                        <div class="form-group mb-4">
                            <label for="client_ref">
                                <strong>
                                    Purchase Order (Client Ref)
                                </strong>
                            </label>
                            <input class="form-control" placeholder="Client ref" name="client_ref" type="text" id="client_ref" v-model="form.client_ref">
                        </div>
                        <div class="form-group">
                            <div class="d-flex align-items-end">
                                <div class="me-4" style="flex: auto;">
                                    <ContactSelect
                                        v-model="form.selectedContact"
                                        title="Contact"
                                        :customer="form.selectedCustomer"
                                        :contact="job.contact"
                                        :required="true"
                                        remove-margin
                                    />
                                </div>
                                <div class="">
                                    <button class="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#contract_contact_modal" >
                                        Create
                                    </button>
                                    <ContactModal
                                        :selected-customer="form.selectedCustomer"
                                        identifier="contract"
                                        :user="user"
                                        @contact-created="handleContactCreated"
                                    />
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </AdminBlock>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-6">
                <AdminBlock title="Collection" heading="Updates made to the Job Collection data will also be made to the first Movement of the Job">
                    <fieldset class="">
                        <div class="form-group mb-4">
                            <label for="collection_date">
                                <strong>
                                    Collection Date
                                </strong>
                            </label>
                            <div class="input-group datetime collection-date">
                                    <span class="input-group-text">
                                        <i class="fa fa-calendar"></i>
                                    </span>
                                <input
                                    v-model="form.collection.date"
                                    class="form-control js-flatpickers"
                                    placeholder="yyyy-mm-dd"
                                    id="collection_date"
                                    name="collection_date"
                                    type="text"
                                >
                            </div>
                        </div>
                        <div class="form-group mb-4">
                            <JobTime
                                title="Collection Time"
                                :time="job.collection_time"
                                @update-time="val => {form.collection.time = val}"
                            />
                        </div>
                        <div class="form-group mb-4">
                            <label>
                                <strong>
                                    Collection Location
                                </strong>
                            </label>
                            <GoogleMap
                                map-for="collection"
                                :location="form.collection.location"
                                :selected-customer="form.selectedCustomer"
                                @location-changed="updateCollectionLocation"
                            />
                        </div>
                        <div class="form-group mb-4">
                            <label for="collection_company">
                                <strong>
                                    Collection Company
                                </strong>
                            </label>
                            <input
                                v-model="form.collection.company"
                                class="form-control"
                                placeholder="Name of company if different from Customer"
                                name="collection_company"
                                type="text"
                                id="collection_company"
                            >
                        </div>
                        <div class="form-group">
                            <div class="d-flex align-items-end">
                                <div class="me-4" style="flex: auto;">
                                    <ContactSelect
                                        v-model="form.collection.contact"
                                        title="Collection Contact"
                                        :customer="form.selectedCustomer"
                                        remove-margin
                                    />
                                </div>
                                <div class="">
                                    <button class="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#collection_contact_modal">
                                        Create
                                    </button>
                                    <ContactModal
                                        :selected-customer="form.selectedCustomer"
                                        identifier="collection"
                                        :user="user"
                                        @contact-created="handleCollectionContactCreated"
                                    />
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </AdminBlock>
            </div>

            <div class="col-lg-6">
                <AdminBlock title="Delivery" heading="Updates made to the Job Delivery data will also be made to the last Movement of the Job">
                    <fieldset class="">
                        <div class="form-group mb-4">
                            <label for="delivery_date">
                                <strong>
                                    Delivery Date
                                </strong>
                            </label>
                            <div class="input-group datetime collection-date">
                                    <span class="input-group-text">
                                        <i class="fa fa-calendar"></i>
                                    </span>
                                <input
                                    v-model="form.delivery.date"
                                    class="form-control js-flatpickers"
                                    placeholder="yyyy-mm-dd"
                                    id="delivery_date"
                                    name="delivery_date"
                                    type="text"
                                >
                            </div>
                        </div>

                        <div class="form-group mb-4">
                            <JobTime
                                title="Delivery Time"
                                :time="job.delivery_time"
                                @update-time="val => {form.delivery.time = val}"
                            />
                        </div>

                        <div class="form-group mb-4">
                            <label>
                                <strong>
                                    Delivery Location
                                </strong>
                            </label>
                            <GoogleMap
                                map-for="delivery"
                                :location="form.delivery.location"
                                :selected-customer="form.selectedCustomer"
                                @location-changed="updateDeliveryLocation"
                            />
                        </div>

                        <div class="form-group mb-4">
                            <label>
                                <strong>
                                    Delivery Company
                                </strong>
                            </label>
                            <input
                                v-model="form.delivery.company"
                                class="form-control"
                                placeholder="Name of company if different from Customer"
                                name="delivery_company"
                                type="text"
                                id="delivery_company"
                            >
                        </div>

                        <div class="form-group">
                            <div class="d-flex align-items-end">
                                <div class="me-4" style="flex: auto;">
                                    <ContactSelect
                                        v-model="form.delivery.contact"
                                        title="Delivery Contact"
                                        :customer="form.selectedCustomer"
                                        remove-margin
                                    />
                                </div>
                                <div class="">
                                    <button
                                        class="btn btn-secondary"
                                        data-bs-toggle="modal"
                                        data-bs-target="#delivery_contact_modal"
                                    >
                                        Create
                                    </button>
                                </div>
                                <ContactModal
                                    :selected-customer="form.selectedCustomer"
                                    identifier="delivery"
                                    :user="user"
                                    @contact-created="handleDeliveryContactCreated"
                                />
                            </div>
                        </div>
                    </fieldset>
                </AdminBlock>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-6">
                <AdminBlock title="Route">
                    <estimate-route
                        :collection="{
                                lat: form.collection.lat,
                                lng: form.collection.lng
                            }"
                        :delivery="{
                                lat: form.delivery.lat,
                                lng: form.delivery.lng
                            }"
                        :mileage="form.mileage"
                        @update-mileage="val => {form.mileage = val}"
                    />
                </AdminBlock>
            </div>

            <div class="col-lg-6">
                <div class="row">
                    <div class="col-12">
                        <AdminBlock title="Vehicle">
                            <div class="form-group mb-2">
                                <div class="d-flex align-items-end">
                                    <div class="me-4" style="flex: auto">
                                        <VehicleSelect
                                            v-model="form.selectedVehicle"
                                            :customer="form.selectedCustomer"
                                            remove-margin
                                            :required="true"
                                        />
                                    </div>
                                    <div class="">
                                        <span class="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#create_vehicle_modal">
                                            Create
                                        </span>
                                        <VehicleModal
                                            identifier="create"
                                            :customer="form.selectedCustomer"
                                            @vehicle-created="vehicle => { form.selectedVehicle = vehicle.data }"
                                        />
                                    </div>
                                </div>
                            </div>
                        </AdminBlock>
                    </div>

                    <div class="col-12">
                        <AdminBlock title="Price">
                            <RoutePrice
                                :job_id="job.id"
                                :contract_id="form.selectedContract?.id"
                                :vehicle_id="form.selectedVehicle?.id"
                                :mileage="form.mileage"
                                :price="form.price"
                                :adblue="form.price_includes_adblue"
                                :fuel="form.price_includes_fuel"
                                @update-price="updatePrice"
                                @update-price-only="val => (form.price = val)"
                                @update-adblue="val => (form.price_includes_adblue = val)"
                                @update-fuel="val => (form.price_includes_fuel = val)"
                            />
                        </AdminBlock>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12">
            <AdminBlock>
                <div class="d-flex justify-content-end">
                    <div class="me-2">
                        <a href="" class="btn btn-secondary">
                            View All Jobs
                        </a>
                    </div>
                    <button @click="updateJobRequest" id="create_contact_form_save" class="btn btn-primary">
                        Save
                    </button>
                </div>
            </AdminBlock>
        </div>
    </div>
</template>

<script setup>

    import axios from 'axios';
    import flatpickr from "flatpickr";
    import AdminBlock from '@/components/movements/components/AdminBlock.vue';
    import ContactModal from "@/components/movements/components/ContactModal.vue";
    import CustomerSelect from "@/components/movements/components/CustomerSelect.vue";
    import ContractSelect from "@/components/movements/components/ContractSelect.vue";
    import ContactSelect from "@/components/movements/components/ContactSelect.vue";
    import VehicleSelect from "@/components/movements/components/VehicleSelect.vue";
    import GoogleMap from "@/components/movements/components/GoogleMap.vue";
    import EstimateRoute from "@/components/movements/components/EstimateRoute.vue";
    import RoutePrice from "@/components/movements/components/RoutePrice.vue";
    import VehicleModal from "@/components/movements/components/VehicleModal.vue";
    import JobTime from "@/components/movements/components/JobTime.vue";
    import { successAlert, errorAlert } from "@/utils";
    import { onMounted, reactive } from 'vue';
    import Swal from 'sweetalert2';

    const props = defineProps({
        user: {
            type: Object,
        },
        job: {
            type: Object,
            default: () => null,
            required: true
        },
    });

    const form = reactive({

        selectedCustomer: props.job.customer ?? null,
        selectedContract: props.job.contract ?? null,
        selectedContact: props.job.contact ?? null,
        selectedVehicle: props.job.vehicle ?? null,

        client_ref: props.job.client_ref ?? "",
        notes: props.job.notes ?? "",
        initial_driver_notes: props.job.initial_driver_notes ?? "",
        aborted_admin_reason: props.job.aborted_admin_reason ?? "",

        price: props.job.price ?? null,
        price_includes_fuel: props.job.price_includes_fuel ?? false,
        price_includes_adblue: props.job.price_includes_adblue ?? false,

        mileage: props.job.mileage ?? null,

        collection: {
            date: props.job.collection_date ?? null,
            time: props.job.collection_time ?? null,
            location: props.job.collection_location ?? null,
            locale: props.job.collection_locale ?? null,
            lat: props.job.collection_lat ?? null,
            lng: props.job.collection_lng ?? null,
            company: props.job.collection_company ?? null,
            contact: props.job.collection_contact ?? null
        },

        delivery: {
            date: props.job.delivery_date ?? null,
            time: props.job.delivery_time ?? null,
            location: props.job.delivery_location ?? null,
            locale: props.job.delivery_locale ?? null,
            lat: props.job.delivery_lat ?? null,
            lng: props.job.delivery_lng ?? null,
            company: props.job.delivery_company ?? null,
            contact: props.job.delivery_contact ?? null
        },

        rate: {
            vehicle_type_id: null,
            minimum_price: null,
            minimum_price_mileage: null,
            price_per_mile_after_min: null
        }

    });

    onMounted(() => {

        flatpickr('.js-flatpickers', {
            dateFormat: "Y-m-d",
            enableTime: false,
            altInput: true,
        });

        flatpickr('.flatpicker-time-only', {
            enableTime: true,
            noCalendar: true,
            dateFormat: "H:i",
            time_24hr: true,
            altInput: true,
        });

        // if (this.isSpecificTime(this.collectionTime)) {
        //     this.$refs.collectionTimeSpecific._flatpickr.setDate(this.collectionTime);
        //     this.collectionTime = 'Specific';
        // }
        //
        // if (this.isSpecificTime(this.deliveryTime)) {
        //     this.$refs.deliveryTimeSpecific._flatpickr.setDate(this.deliveryTime);
        //     this.deliveryTime = 'Specific';
        // }

    });

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const formatter = new Intl.DateTimeFormat('en-GB', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        });
        return formatter.format(date);
    };

    const updatePrice = (data) => {
        form.price = data.price;
        form.rate.minimum_price = data.rate.minimum_price;
        form.rate.minimum_price_mileage = data.rate.minimum_price_mileage;
        form.rate.price_per_mile_after_min = data.rate.price_per_mile_after_min;
        form.rate.vehicle_type_id = data.rate.vehicletype_id;
    };

    const generateMoveRoute = () => {
        return route('movements.jobs.move.index', { job: props.job.id });
    };

    const updateDeliveryLocation = (data) => {
        if (data.location !== null && data.location !== '') {
            form.delivery.location = data.location;
        }
        if (data.latitude !== null && data.longitude !== null) {
            form.delivery.lat = data.latitude;
            form.delivery.lng = data.longitude;
        }
        if (data.locale !== null && data.locale !== '') {
            form.delivery.locale = data.locale;
        }
    };

    const updateCollectionLocation = (data) => {
        if (data.location !== null && data.location !== '') {
            form.collection.location = data.location;
        }
        if (data.latitude !== null && data.longitude !== null) {
            form.collection.lat = data.latitude;
            form.collection.lng = data.longitude;
        }
        if (data.locale !== null && data.locale !== '') {
            form.collection.locale = data.locale;
        }
    };

    const isSpecificTime = (time) => {
        return time !== 'Any' &&
            time !== 'AM' &&
            time !== 'PM' &&
            time !== 'Evening' &&
            time !== 'Night';
    };

    const updateJobRequest = async () => {

        // Check for TBC warning
        if (form.client_ref && form.client_ref.trim().toUpperCase() === 'TBC') {
            const result = await Swal.fire({
                title: 'Warning: TBC Purchase Order',
                html: '<p>The PO Reference is set to "TBC".</p><p>This will need to be updated with a valid PO reference before invoicing.</p>',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Continue Anyway',
                cancelButtonText: 'Go Back',
                confirmButtonColor: '#ffc107',
                cancelButtonColor: '#6c757d',
            });

            if (!result.isConfirmed) {
                return;
            }
        }

        const data = {};

        data.notes = form.notes;
        data.initial_driver_notes = form.initial_driver_notes;
        data.aborted_admin_reason = form.aborted_admin_reason;
        data.mileage = form.mileage;

        data.contract_id = form.selectedContract?.id;
        data.client_ref = form.client_ref;
        data.contact_id = form.selectedContact?.id;

        data.collection_date = form.collection.date;
        data.collection_time = form.collection.time;

        data.collection_location = form.collection.location;
        data.collection_lat = form.collection.lat;
        data.collection_lng = form.collection.lng;
        data.collection_locale = form.collection.locale;
        data.collection_company = form.collection.company;
        data.collectioncontact_id = form.collection.contact?.id;

        data.delivery_date = form.delivery.date;
        data.delivery_time = form.delivery.time;

        data.delivery_location = form.delivery.location;
        data.delivery_lat = form.delivery.lat;
        data.delivery_lng = form.delivery.lng;
        data.delivery_locale = form.delivery.locale;
        data.delivery_company = form.delivery.company;
        data.deliverycontact_id = form.delivery.contact?.id;

        data.vehicle_id = form.selectedVehicle?.id;
        data.price = form.price;
        data.price_includes_fuel = form.price_includes_fuel;
        data.price_includes_adblue = form.price_includes_adblue;

        axios.post(route('api.movements.jobs.update', { job: props.job.id }), data)
            .then(() => {
                successAlert("Job Updated", "Success", 2000, true).then(() => {
                    window.location.href = route('movements.jobs.show', { job: props.job.id });
                });
            })
            .catch(errors => errorAlert(errors, 'Error Updating Job'));
    }

    function handleContactCreated(contact) {
        form.selectedContact = contact.data;
    }

    function handleCollectionContactCreated(contact) {
        form.collection.contact = contact.data;
    }

    function handleDeliveryContactCreated(contact) {
        form.delivery.contact = contact.data;
    }

    function backToJobLink() {
        return route('movements.jobs.show', { job: props.job.id });
    }
</script>
